export default __webpack_public_path__ + "static/media/filling-up-circle.fda5996a.gif";